import React from 'react';
import FinalWinnerContainer from 'containers/finalWinner';
import NewsLetterContainer from 'containers/newsletter';
import HeaderContainer from '../../containers/header';
import FooterContainer from '../../containers/footer';

const FinalWinnerPage = () => {
  return (
    <>
      <HeaderContainer />
      <FinalWinnerContainer />
      <NewsLetterContainer />
      <FooterContainer />
    </>
  );
};

export default FinalWinnerPage;
